'use client';

import * as React from 'react';
import { ProgressProvider } from '@bprogress/next/app';
import { ThemeProvider as NextThemesProvider } from 'next-themes';
import { type ThemeProviderProps } from 'next-themes';

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
    return (
        <NextThemesProvider {...props}>
            <ProgressProvider
                height='5px'
                options={{ showSpinner: false }}
                color={'#5a72f3'}
                shallowRouting
            />
            {children}
        </NextThemesProvider>
    );
}
